import { graphql } from '@/gql';

import './optionFieldsFragment';
import './valueFieldsFragment';

graphql(`
  fragment EstimateFragment on EstimateType {
    total
    storeId
    menuId
    charges {
      title
      value
      originalValue
      tooltips {
        title
        value
      }
    }
    service
    timeEstimate {
      min
      max
    }
    userCharges {
      credits
      card
      expiringCredits
    }
    accountId
    currency
    serviceEstimateReference
    orderOptions {
      storeInstructions
      deliveryInstructions
      dropoffOptionId
    }
    address {
      placeId
      latitude
      longitude
      name
      formattedAddress
      streetNumber
      postalCode
      streetAddress
      streetAddress2
      state
      city
      country
    }
    additionalCharges {
      tip
      serviceFee
    }
    chargeOptions {
      plan
      tier
      applyDiscountedFee
      noServiceFee
      doNotCharge
      chargeNow
      reason
    }
    callSid
    promotion {
      promotionUuid
      text
      description
    }
    isSpecialInstructionsDisabled
    items {
      item {
        id
        storeId
        storeTitle
        title
        subtitle
        service
        price
        quantity
        currency
        specialInstructions
        serviceItemReference
        substitutionPreference
      }
      options {
        ...OptionsFields
        values {
          ...ValuesFields
          subOptions {
            ...OptionsFields
            values {
              ...ValuesFields
              subOptions {
                ...OptionsFields
                values {
                  ...ValuesFields
                  subOptions {
                    ...OptionsFields
                    values {
                      ...ValuesFields
                      subOptions {
                        ...OptionsFields
                        values {
                          ...ValuesFields
                          subOptions {
                            ...OptionsFields
                            values {
                              ...ValuesFields
                              subOptions {
                                ...OptionsFields
                                values {
                                  ...ValuesFields
                                  subOptions {
                                    ...OptionsFields
                                    values {
                                      ...ValuesFields
                                      subOptions {
                                        ...OptionsFields
                                        values {
                                          ...ValuesFields
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);
